import { faHouse, faUser, faLayerGroup, faEnvelope } from "@fortawesome/free-solid-svg-icons"
export const navbarLinks = [
    {id : 1 , title: 'Home' , classname : 'home' , href : "#home" , icon: faHouse},
    {id : 2 , title : 'About' , classname : 'about' , href : "#about" , icon: faUser},
    {id : 3 , title : 'Showcase' , classname : 'showcase' , href : "#showcase" , icon: faLayerGroup},
    {id : 4 , title : 'Contact' , classname : 'contact' , href : "#contact" , icon: faEnvelope}
]